var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLogoNoText = function SvgLogoNoText(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 256.51C50 142.455 142.183 50 255.883 50C369.603 50 461.787 142.455 461.776 256.5C461.776 296.896 450.208 334.579 430.221 366.4C424.711 375.168 418.572 383.488 411.845 391.312L256.157 235.164L122.278 369.427L100.174 391.596C93.4275 383.793 87.2685 375.482 81.7577 366.725C61.6394 334.843 50 297.038 50 256.51ZM406.618 336.976L408.503 333.197L408.513 333.207C420.324 309.575 426.564 283.048 426.564 256.51C426.564 162.125 350.001 85.3361 255.893 85.3361C161.785 85.3361 85.2323 162.125 85.2323 256.51C85.2323 283.19 91.5332 309.829 103.456 333.553L105.351 337.312L256.157 186.061L406.618 336.976ZM255.891 463C307.149 463 354.041 444.214 390.084 413.125V413.115L256.165 278.801L121.992 413.359C157.984 444.316 204.633 463 255.891 463Z",
    fill: "url(#paint0_linear_6469_19394)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6469_19394",
    x1: 255.888,
    y1: 50,
    x2: 256.499,
    y2: 463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#169E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#00C537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1C9"
  })))));
};
export default SvgLogoNoText;